import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { notification } from 'antd';
import storage from '../../services/storage';
import { injectIntl } from 'react-intl';
import ANNOUNDEMENT_MESSAGE_KEY from '../../common/lang/announcement-message-key';
import * as paths from '../../common/paths';
import { LoginUserVO } from '../login/typing';
import Modal from 'antd/lib/modal/Modal';
import { agreeAnnouncement, getAnnouncement } from './action/announcement';
import { logout } from '../layout/action/layout';

require('./announcement.scss');

/**
 * 系统公告
 * 
 * @author Jiawei Chen
 * @since 18/5/2022
 */
class Announcement extends React.PureComponent<any, any> {
  private announcementTitle: string;
  private agreeButtonTxt: string;
  private disagreeButtonTxt: string;
  private disagreeTips: string;
  private exitButtonTxt: string;
  private readAgainButtonTxt: string;

  constructor(props) {
    super(props);
    this.announcementTitle = this.fmtMessage(ANNOUNDEMENT_MESSAGE_KEY.ANNOUNCEMENT_TITLE);
    this.agreeButtonTxt = this.fmtMessage(ANNOUNDEMENT_MESSAGE_KEY.AGREE_ANNOUNCEMENT_BUTTON);
    this.disagreeButtonTxt = this.fmtMessage(ANNOUNDEMENT_MESSAGE_KEY.DISAGREE_ANNOUNCEMENT_BUTTON);
    this.disagreeTips = this.fmtMessage(ANNOUNDEMENT_MESSAGE_KEY.DISAGREE_ANNOUNCEMENT_TIPS);
    this.exitButtonTxt = this.fmtMessage(ANNOUNDEMENT_MESSAGE_KEY.EXIT_BUTTON);
    this.readAgainButtonTxt = this.fmtMessage(ANNOUNDEMENT_MESSAGE_KEY.READ_AGAIN_BUTTON);

    this.state = {
      announcementContent: '',
      disagreeFlag: false,
      agreeButtonClicked: false,
    };
  }

  /**
   * 控件mount后执行
   */
  componentDidMount () {
    const userInfo = storage.getUserInfo() as LoginUserVO;
    // 用户未进行登录则跳转到登录页
    if (!userInfo || !userInfo.announcementInfo) {
      this.gotoLogin();
      return;
    } else if (userInfo.announcementInfo.agreed) {
      // 用户若已同意，则直接跳去pyxis的桌面
      this.gotoDeskTop();
      return;
    }
    this.getAnnouncement(userInfo.announcementInfo.announcementPath);
  }

  /**
   * 获取公告信息
   * @param announcementPath 公告路径
   */
  private getAnnouncement = (announcementPath: string) => {
    getAnnouncement(announcementPath)
      .then(d => this.setState({
        announcementContent: d,
      }))
      .catch(err => {
        // 错误信息
        const errorMessage = this.fmtMessage(ANNOUNDEMENT_MESSAGE_KEY.GET_ANNOUNCEMENT_ERROR);
        this.showError(errorMessage);
        console.error(errorMessage, err);
        // 用户登出
        this.logout();
      });
  };

  /**
   * 
   * @param adaNumber 同意公告
   * @param selectedVisitedLinkConfig 
   */
  private agreeAnnouncement = () => {
    this.setState({
      agreeButtonClicked: true,
    }, this.doAgreeAnnouncement);
  };

  private doAgreeAnnouncement = () => {
    agreeAnnouncement()
      .then(result => {
        if (result) {
          // 同意公告操作成功后，跳转至pyxis桌面
          if (result.code === '0') {
            const userInfo = storage.getUserInfo() as LoginUserVO;
            userInfo.announcementInfo.agreed = true;
            storage.setUserInfo(userInfo);
            this.gotoDeskTop();
          } else {
            // 输出错误信息，并登出
            this.showError(result.message);
            this.logout();
          }
        }
      }).catch(err => {
        if (err && err.response && err.response.status == 403) {
          this.logout();
        } else {
          this.showError(this.fmtMessage(ANNOUNDEMENT_MESSAGE_KEY.NETWORK_ERROR));
          this.setState({agreeButtonClicked: false});
        }
      });
  };

  /**
   * 用户登出
   */
  private logout = () => {
    logout().finally(
      () => {
        // 清除用户在 local storage 的信息
        storage.removeInfo();
        // 跳转到登录页面
        this.gotoLogin();
      }
    );
  }

  private fmtMessage = (id, params = {}) => {
    const { intl } = this.props;
    return intl.formatMessage({id}, params);
  };

  showError = (description: string) => {
    notification['error']({
      message: null,
      description,
      placement: 'top',
    });
  };

  private gotoLogin = () => {
    storage.removeInfo();
    const { history } = this.props;
    history.push(paths.LOGIN_PATH);
  };

  private gotoDeskTop = () => {
    this.props.history.push({pathname: paths.PYXIS_PATH});
  };

  private toggleDisagree = () => {
    const { disagreeFlag } = this.state
    this.setState({
      disagreeFlag: !disagreeFlag,
    });
  };

  private renderAnnouncementDialog = () => {
    const { announcementContent, disagreeFlag, agreeButtonClicked } = this.state;
    return <Modal
      title={this.announcementTitle}
      centered
      maskClosable={false}
      visible={!disagreeFlag}
      className='announcement announcement-dialog'
      okText={this.agreeButtonTxt}
      cancelText={this.disagreeButtonTxt}
      onOk={this.agreeAnnouncement}
      okButtonProps={{loading: agreeButtonClicked}}
      onCancel={this.toggleDisagree}
      closable={false}
    >
      <div dangerouslySetInnerHTML={{ __html: announcementContent }} />
    </Modal>;
  };

  private renderExitWarningDialog = () => {
    const { disagreeFlag } = this.state;
    return <Modal
      className='announcement exit-warning-dialog'
      centered
      maskClosable={false}
      visible={disagreeFlag}
      okText={this.readAgainButtonTxt}
      cancelText={this.exitButtonTxt}
      onOk={this.toggleDisagree}
      onCancel={this.logout}
      closable={false}
    >
      {this.disagreeTips}
    </Modal>;
  };

  render() {
    return <>
      { this.renderExitWarningDialog() }
      { this.renderAnnouncementDialog() }
    </>
  }
}

(Announcement as React.ComponentType).defaultProps = {
  loading: true,
  location: { pathname: '' },
};

(Announcement as React.ComponentType<any>).contextTypes = {
  numeric: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(withRouter(Announcement));
